export default {"src":"/_next/static/media/back.084c3083.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};